import { SystemField } from "./system-field";

export class PurchaseBillPayment extends SystemField{
     
     purchase_bills_id?:string;
     purchase_payments_id?:string;
     amount?:number;
}
export class PurchaseBillPaymentTranslation extends SystemField{
    
    lang_code?:string;
    description?:string;
    purchase_bills_id?:string;
    
}